import React from "react";
import logo3D from "../assets/sc-logo-3d-transparent.png";

/**
 * Brand logo — premium 3D Masonic Square & Compass with G in the center.
 * The PNG has a transparent background so it sits cleanly on any surface
 * (navy sidebar, white login card, dashboard tiles).
 *
 * `variant` and `color` props are kept for backwards compatibility with
 * existing call sites but are now ignored — the same 3D asset is rendered
 * everywhere.
 */
// eslint-disable-next-line no-unused-vars
export function CompassLogo({ size = 64, variant = "auto", color = null }) {
  return (
    <img
      src={logo3D}
      alt="Square & Compass"
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        userSelect: "none",
        display: "block",
        filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.18))",
      }}
    />
  );
}
